import ls from '../store/ls';
const tokenKey = 'csrftoken';

export function getToken() {
    return ls.getItem(tokenKey);
}

export function setToken(token) {
    return ls.setItem(tokenKey, token || '');
}

export function removeToken() {
    return ls.removeItem(tokenKey);
}

export function getJid() {
    return ls.getItem('prisjsessionid');
}

export function setJid(jid) {
    return ls.setItem('prisjsessionid', jid || '');
}
